import type { RewardEvent } from '@pebblecode/shared';

import type { Messages } from '../i18n/index.js';

const LANG_NAMES: Record<string, string> = {
  cpp: 'C++',
  pseudo: 'Pseudocod',
  py: 'Python',
  js: 'JavaScript',
};

/** What a points event was for, in the UI language. */
export function eventLabel(e: RewardEvent, t: Messages, titles: Map<string, string>): string {
  const ev = t.rewards.event;
  const title = (slug: string | null) => (slug && titles.get(slug)) || slug || '';
  switch (e.kind) {
    case 'solve':
      return ev.solve(title(e.detail));
    case 'no-hint':
      return ev['no-hint'](title(e.detail));
    case 'daily':
      return ev.daily;
    case 'streak':
      return ev.streak(e.detail ?? '');
    case 'step':
      return ev.step;
    case 'lang':
      return ev.lang(LANG_NAMES[e.detail ?? ''] ?? e.detail ?? '');
    case 'live':
      return ev.live;
  }
}
